/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Sent_ToastInputs */



/**
* | output |
* | --- |
* | "Assignment notification email sent" |
*
* @param {Explorer_Assignment_Email_Sent_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_sent_toast = /** @type {((inputs?: Explorer_Assignment_Email_Sent_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Sent_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("E-mail de notification d'affectation envoye")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benachrichtigungs-E-Mail zur Zuweisung gesendet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email di notifica di assegnazione inviata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Письмо с уведомлением о назначении отправлено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo de notificación de asignación enviado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已发送分配通知邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("割り当て通知メールを送信しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असाइनमेंट सूचना ईमेल भेजा गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("E-mail de notificação de atribuição enviado")
	return /** @type {LocalizedString} */ ("Assignment notification email sent")
});